// Passphrase / PIN field with "show" (Tool Plan §4.15; I-1a Batch 4).
// No spell check, autocorrect or capitalisation: the keyboard must not learn or
// change the secret. Numeric keypad for digit locks. The toggle keeps the label
// "Show" and reports its state with aria-pressed ("Hide" is the Batch 5
// quick-hide control, so it is never used as a label here).

import { useState } from 'react'

import { common } from '../screens/copy'

interface SecretFieldProps {
  readonly id: string
  readonly label: string
  readonly value: string
  readonly onChange: (value: string) => void
  readonly numeric?: boolean
  readonly autoFocus?: boolean
  readonly disabled?: boolean
}

export function SecretField({ id, label, value, onChange, numeric, autoFocus, disabled }: SecretFieldProps): React.JSX.Element {
  const [shown, setShown] = useState(false)
  return (
    <div className="field">
      <label className="field__label" htmlFor={id}>
        {label}
      </label>
      <div className="field__row">
        <input
          id={id}
          className="field__input"
          type={shown ? 'text' : 'password'}
          inputMode={numeric ? 'numeric' : 'text'}
          autoComplete="off"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          autoFocus={autoFocus}
          disabled={disabled}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        <button
          type="button"
          className="button button--quiet field__toggle"
          aria-pressed={shown}
          aria-controls={id}
          onClick={() => setShown((s) => !s)}
        >
          {common.show}
        </button>
      </div>
    </div>
  )
}
